import { render, staticRenderFns } from "./Organ.vue?vue&type=template&id=dfb6f4dc&scoped=true"
import script from "./Organ.vue?vue&type=script&lang=js"
export * from "./Organ.vue?vue&type=script&lang=js"
import style0 from "./Organ.vue?vue&type=style&index=0&id=dfb6f4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb6f4dc",
  null
  
)

export default component.exports